import React from "react";
import { Route } from "react-router-dom";
import Home from "./Home";
import Pairings from "./Pairings";

const App = () => (
  <div>
    <Route exact path="/" component={Home} />
    <Route path="/:rnd/:tee" component={Pairings} />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js